import type { TenantScope } from '@onefootprint/request-types/dashboard';

import type { DecryptOption } from '../../hooks/use-decrypt-options';
import { decryptOptionFromTenantScope } from '../../hooks/use-decrypt-options';
import type { VaultProxyOption } from '../../hooks/use-vault-proxy-options';
import { vaultProxyOptionFromTenantScope } from '../../hooks/use-vault-proxy-options';

/// Separate scopes into "decrypt" scopes that are displayed in the decrypt dropdown and
/// "non-decrypt" scopes that have their own checkboxes
export const groupTenantRoleScopes = (scopes: TenantScope[]) => {
  const decryptOptions: DecryptOption[] = [];
  const basicScopes: TenantScope[] = [];
  const vaultProxyOptions: VaultProxyOption[] = [];

  scopes.forEach(scope => {
    const decryptOption = decryptOptionFromTenantScope(scope);
    const proxyOption = vaultProxyOptionFromTenantScope(scope);
    if (decryptOption) {
      decryptOptions.push(decryptOption);
    } else if (proxyOption) {
      vaultProxyOptions.push(proxyOption);
    } else if (
      scope.kind !== 'decrypt' &&
      scope.kind !== 'decrypt_all' &&
      scope.kind !== 'decrypt_custom' &&
      scope.kind !== 'decrypt_document' &&
      scope.kind !== 'invoke_vault_proxy' &&
      // Implicit for Auditor roles (handled like `read`); never shown as a toggle.
      scope.kind !== 'entity_read' &&
      // Backend still emits write_lists, but the lists feature has been removed from the UI.
      scope.kind !== 'write_lists'
    ) {
      basicScopes.push(scope);
    }
  });
  const isAdmin = scopes.some(s => s.kind === 'admin');
  return { isAdmin, decryptOptions, basicScopes, vaultProxyOptions };
};
